import styled from 'styled-components';
import { Button } from 'shared-ui';

export const ActionButton = styled(Button)`
  min-width: 36px;
  height: 36px;
  padding: 0;
`;
